import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../common/components/state/state.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../../common/services/notification.service';
import { AnalyticsService } from '../../../../../common/services/analytics.service';
import { CompetitionGroupApiService } from '../../../../../common/apis/competition-group/competition-group-api.service';
import { ICompetitionGroupModel } from '../../../../../common/apis/competition-group/model/competitoin-group.model';
import { TeamsListComponent } from '../../../../../common/modules/teams-list/teams-list.component';
import { ListHeaderComponent } from '../../../../../common/components/list-header/list-header.component';
import { LoadingContainerComponent } from '../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-tournament-configurations',
  templateUrl: './tournament-configurations.component.html',
  styleUrls: ['./tournament-configurations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingContainerComponent, ListHeaderComponent, TeamsListComponent],
})
export class TournamentConfigurationsComponent extends StateComponent<TournamentConfigurationsComponentState> implements OnInit {

  state: TournamentConfigurationsComponentState = {
    status: 'ready',
    currentSelectedTeamId: null,
    prevSelectedTeamId: null,
    compGroup: null!,
  };
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);
  private readonly notificationService = inject(NotificationService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly compGroupApi = inject(CompetitionGroupApiService);

  ngOnInit(): void {
    this.analyticsService.trackScreenName('tournamentConfiguration');
    this.fetchData();
  }

  teamOpened(teamId: string): void {
    this.updateState({
      prevSelectedTeamId: this.state.currentSelectedTeamId,
      currentSelectedTeamId: teamId,
    });
  }

  private fetchData() {
    this.updateStatus('loading');
    this.compGroupApi.getCompGroup(this.route.snapshot.paramMap.get('compGroupId')!)
      .then((compGroup) => {
        this.updateState({
          status: 'ready',
          compGroup,
        });
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface TournamentConfigurationsComponentState {
  status: ComponentStatus;
  currentSelectedTeamId: string | null;
  prevSelectedTeamId: string | null;
  compGroup: ICompetitionGroupModel;
}
